// AI Enhance — uses the buyer's Groq API key (from Settings) to polish the
// logic-refined prompt. The PWA works fully without this; the key is optional.
//
// Public API stays the same so App.tsx doesn't need to change.

import { streamGroq, GroqMissingKeyError } from './groq-client'

const SYSTEM_PROMPT = `You are an elite prompt engineer. Take the user's rough prompt and the logic-refined version, then produce the FINAL polished prompt. Preserve all structure. Add professional nuance. Keep all placeholders. Explain your key improvements in 2 bullets at the end.`

export async function aiEnhancePrompt(
  original: string,
  logicRefined: string,
  onStream: (chunk: string) => void
): Promise<void> {
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: SYSTEM_PROMPT },
        {
          role: 'user',
          content: `Original: ${original}\n\nLogic-refined: ${logicRefined}\n\nProduce the final enhanced prompt.`,
        },
      ],
      temperature: 0.3,
      onStream,
    })
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream(
        '\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.'
      )
      return
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`)
  }
}
